import { PRIMARY_KEY_NAME, TYPENAME_KEY_NAME } from "../bindingTypes.js";
import { LocalizedBindingError } from "./exceptions/LocalizedBindingError.js";
import { FieldMarker } from "../markers/FieldMarker.js";
import { HasOneRelationMarker } from "../markers/HasOneRelationMarker.js";
import { HasManyRelationMarker } from "../markers/HasManyRelationMarker.js";
import { assertNever } from "../utils/assertNever.js";
class MarkerComparator {
  static isSubTreeSubsetOf(candidate, superset) {
    if (candidate.placeholderName !== superset.placeholderName) {
      return false;
    }
    return this.isSubsetOf(candidate.fields, superset.fields);
  }
  static assertEntityMarkersSubsetOf(candidate, superset) {
    this.assertSubsetOf(candidate, superset);
  }
  static assertSubsetOf(candidate, superset) {
    for (const [placeholderName, candidateMarker] of candidate.markers) {
      const fromSuperset = superset.markers.get(placeholderName);
      if (fromSuperset === void 0) {
        if (candidateMarker instanceof FieldMarker) {
          if (candidateMarker.fieldName === PRIMARY_KEY_NAME || candidateMarker.fieldName === TYPENAME_KEY_NAME) {
            continue;
          }
          throw new LocalizedBindingError(`The field '${candidateMarker.fieldName}' is missing.`, [candidateMarker]);
        }
        if (candidateMarker instanceof HasOneRelationMarker || candidateMarker instanceof HasManyRelationMarker) {
          const differentPlaceholders = superset.placeholders.get(candidateMarker.parameters.field);
          if (differentPlaceholders === void 0) {
            throw new LocalizedBindingError(`The relation '${candidateMarker.parameters.field}' is missing.`, [
              candidateMarker
            ]);
          }
          throw new LocalizedBindingError(
            `The relation '${candidateMarker.parameters.field}' exists but its parameters don't match exactly. Check that all relation parameters are the same.`,
            [candidateMarker]
          );
        }
        assertNever();
      }
      if (candidateMarker instanceof FieldMarker) {
        continue;
      }
      try {
        if (candidateMarker instanceof HasOneRelationMarker && fromSuperset instanceof HasOneRelationMarker || candidateMarker instanceof HasManyRelationMarker && fromSuperset instanceof HasManyRelationMarker) {
          this.assertSubsetOf(candidateMarker.fields, fromSuperset.fields);
        }
      } catch (e) {
        if (e instanceof LocalizedBindingError) {
          throw e.nestedIn(candidateMarker);
        }
        throw e;
      }
    }
  }
  static isSubsetOf(candidate, superset) {
    for (const [placeholderName, candidateMarker] of candidate.markers) {
      const fromSuperset = superset.markers.get(placeholderName);
      if (fromSuperset === void 0) {
        if (candidateMarker instanceof FieldMarker && (candidateMarker.fieldName === PRIMARY_KEY_NAME || candidateMarker.fieldName === TYPENAME_KEY_NAME)) {
          continue;
        }
        return false;
      }
      if (candidateMarker instanceof FieldMarker || fromSuperset instanceof FieldMarker) {
        continue;
      }
      if (!this.isSubsetOf(candidateMarker.fields, fromSuperset.fields)) {
        return false;
      }
    }
    return true;
  }
  //private static assertAreMarkersSubsetOf(): {}
}
export {
  MarkerComparator
};
//# sourceMappingURL=MarkerComparator.js.map
